import { endPoints } from "../../constant/api_constants/url";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";

//App Messages
export const getAppToastMessage = async (accessJWT: string): Promise<any> => {
  const endpoint = endPoints.getApplicationToastMessages;
  return await fetchApi(accessJWT, endpoint, API_METHODS.GET);
};
